module.exports = __webpack_public_path__ + "static/media/radioOne.4c7edeb2.png";